<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M6.5 21.5c-1.101 0-2-.9-2-2v-17h15v19h-13zM7 6.5h10m-10 3h8m-8 3h6"/>
</svg>
